import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 销账查询 条件查询
export function queryActualAmountPageable(data) {
  return request({
    url: URL.act.writeoff.queryActualAmountPageable,
    method: 'post',
    data
  })
}

// 销账查询 条件查询
export function queryActualAmountOldPageable(data) {
  return request({
    url: URL.act.writeoff.queryActualAmountOldPageable,
    method: 'post',
    data
  })
}

// 销账查询 复核/取消复核
export function batchUpdateApprovedState(data) {
  return request({
    url: URL.act.writeoff.batchUpdateApprovedState,
    method: 'put',
    data
  })
}
// 销账查询 刷新汇率
export function refreshEmptyRate() {
  return request({
    url: URL.act.writeoff.refreshEmptyRate,
    method: 'put'
  })
}
// 销账查询 刷新实际收付金额
export function refreshEmpyPaymentAmount() {
  return request({
    url: URL.act.writeoff.refreshEmpyPaymentAmount,
    method: 'put'
  })
}
// 销账查询 修改销账
export function updateActualAmount(data) {
  return request({
    url: URL.act.writeoff.updateActualAmount,
    method: 'put',
    data
  })
}
// 销账查询 修改销账-同步费用上的收付日期
export function synchronizationChargeByPayReceiveDate(data) {
  return request({
    url: URL.act.writeoff.synchronizationChargeByPayReceiveDate,
    method: 'put',
    data
  })
}
// 销账查询 撤销销账-回滚费用冲销
export function rollbackChargeWriteoff(data) {
  return request({
    url: URL.act.writeoff.rollbackChargeWriteoff,
    method: 'put',
    data
  })
}
// 销账查询 撤销销账-检查导出到凭证
export function checkExportedToVoucher(data) {
  return request({
    url: URL.act.writeoff.checkExportedToVoucher,
    method: 'put',
    data
  })
}
// 销账查询 撤销销账-根据id数组列表查找销账明细
export function queryActualAmountsByID(data) {
  return request({
    url: URL.act.writeoff.queryActualAmountsByID,
    method: 'post',
    data
  })
}
